import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import styledNative from "@rentiohq/shared-frontend/dist/components/theme/styled-components.native";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { View } from "react-native";

export const LisWrap = styledNative(View)`
  margin-top: 24px;
  padding-left: 0px;
  padding-right: 0px;
`;

export const ButtonPrimaryWrap = styled.div`
  margin-left: 16px;
  margin-right: 16px;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    margin-left: 40px;
    margin-right: 40px;
  }
`;
